import { concatAST } from 'graphql'

import customerFragment from './customer.fragment.graphql'
import documentFragment from './document.fragment.graphql'
import documentNatifMetadataFragment from './document-natif-metadata.fragment.graphql'
import documentPaymentMetadataFragment from './document-payment-metadata.fragment.graphql'
import documentRecipientMetadataFragment from './document-recipient-metadata.fragment.graphql'
import documentScanMetadataFragment from './document-scan-metadata.fragment.graphql'
import documentSenderFragment from './document-sender.fragment.graphql'
import documentSubjectFragment from './document-subject.fragment.graphql'
import documentTaggerFragment from './document-tagger.fragment.graphql'
import documentTagsFragment from './document-tags.fragment.graphql'

export default concatAST([
  documentPaymentMetadataFragment,
  documentTagsFragment,
  documentTaggerFragment,
  documentSubjectFragment,
  documentSenderFragment,
  customerFragment,
  documentFragment,
  documentNatifMetadataFragment,
  documentRecipientMetadataFragment,
  documentScanMetadataFragment,
])
